'use client';

import { useCallback, useEffect, useRef } from 'react';
import { getAssetUrl } from 'lib/config/assetUrls';
import styles from './PartnerLogoMarquee.module.css';

export const PartnerLogoMarquee = ({ className }: { className?: string }) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const animate = useCallback(() => {
    const width = contentRef.current?.getBoundingClientRect().width ?? 0;
    if (width > window.innerWidth) {
      const spacing = (width - window.innerWidth) / 2;
      contentRef.current?.style.setProperty('--spacing', `${spacing}px`);
      contentRef.current?.style.setProperty('--spacingInv', `${-spacing}px`);
      contentRef.current?.style.setProperty('--timing', `${spacing / 10}s`);
      contentRef.current?.classList.add('animate');
    } else {
      contentRef.current?.classList.remove('animate');
    }
  }, []);

  useEffect(() => {
    // Wait for images to load before animating
    const images = contentRef.current?.querySelectorAll('img') ?? [];
    const imageLoadPromises = Array.from(images).map((img) => {
      if (img.complete) return Promise.resolve();
      return new Promise((resolve) => {
        img.addEventListener('load', () => resolve(null));
        img.addEventListener('error', () => resolve(null));
      });
    });

    Promise.all(imageLoadPromises).then(() => {
      animate();
    });

    window.addEventListener('resize', animate);
    return () => {
      window.removeEventListener('resize', animate);
    };
  }, [animate]);

  return (
    <div className={`${styles.root}${className ? ` ${className}` : ''}`}>
      <div ref={contentRef}>
        <img
          loading="lazy"
          src={getAssetUrl('/web_v2/partners/partner-logos/for-marquee/02.png')}
          alt="02"
          height="41px"
        />
        <img
          loading="lazy"
          src={getAssetUrl('/web_v2/partners/partner-logos/for-marquee/03.png')}
          alt="03"
          height="46px"
        />
        <img
          loading="lazy"
          src={getAssetUrl('/web_v2/partners/partner-logos/for-marquee/01.png')}
          alt="01"
          height="39px"
        />
        <img
          loading="lazy"
          src={getAssetUrl('/web_v2/partners/partner-logos/for-marquee/04.png')}
          alt="04"
          height="41px"
        />
        <img
          loading="lazy"
          src={getAssetUrl('/web_v2/partners/partner-logos/for-marquee/05.png')}
          alt="05"
          height="48px"
        />
        <img
          loading="lazy"
          src={getAssetUrl('/web_v2/partners/partner-logos/for-marquee/06.png')}
          alt="06"
          height="32px"
        />
        <img
          loading="lazy"
          src={getAssetUrl(
            '/web_v2/partners/partner-logos/for-marquee/07-v2.png',
          )}
          alt="07"
          height="48px"
        />
        <img
          loading="lazy"
          src={getAssetUrl(
            '/web_v2/partners/partner-logos/for-marquee/08-v2.png',
          )}
          alt="08"
          height="48px"
        />
        <img
          loading="lazy"
          src={getAssetUrl('/web_v2/partners/partner-logos/for-marquee/09.png')}
          alt="09"
          height="48px"
        />
      </div>
    </div>
  );
};
